// src/LandingPage.jsx
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Kanit:wght@300;400;500;600;700;800;900&family=DM+Serif+Display:ital@0;1&family=Space+Mono:wght@400;700&display=swap');
  .jkl-land * { margin: 0; padding: 0; box-sizing: border-box; }
  .jkl-land {
    --black:#07070a;--deep:#0a0a0f;--card:#0f0f16;--border:rgba(255,255,255,0.07);
    --gold:#d4a550;--gold-lt:#f0c878;--gold-dim:rgba(212,165,80,0.12);
    --white:#f0ece4;--muted:#8a8a9a;--faint:#2a2a38;
    background:var(--black);color:var(--white);font-family:'Kanit',sans-serif;overflow-x:hidden;
  }
  .jkl-land a{cursor:pointer;}
  .jkl-land::before{content:'';position:fixed;inset:0;background-image:url("data:image/svg+xml,%3Csvg viewBox='0 0 512 512' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.75' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.035'/%3E%3C/svg%3E");pointer-events:none;z-index:1000;opacity:0.5;}
  .jkl-nav{position:fixed;top:0;left:0;right:0;z-index:200;display:flex;align-items:center;justify-content:space-between;padding:0 48px;height:64px;background:rgba(7,7,10,0.85);backdrop-filter:blur(24px);border-bottom:1px solid var(--border);}
  .jkl-nav-logo{font-family:'Kanit',sans-serif;font-size:22px;font-weight:900;letter-spacing:0.2em;color:var(--white);text-transform:uppercase;text-decoration:none;}
  .jkl-nav-links{display:flex;align-items:center;gap:32px;list-style:none;}
  .jkl-nav-links a{font-family:'Space Mono',monospace;font-size:11px;letter-spacing:0.12em;color:var(--muted);text-decoration:none;text-transform:uppercase;transition:color 0.2s;}
  .jkl-nav-links a:hover{color:var(--gold);}
  .jkl-nav-cta{font-family:'Kanit',sans-serif!important;font-size:13px!important;font-weight:600!important;color:var(--black)!important;background:var(--gold);padding:8px 22px;border-radius:4px;transition:background 0.2s!important;}
  .jkl-nav-cta:hover{background:var(--gold-lt)!important;}
  .jkl-lang-switch{display:flex;align-items:center;gap:6px;}
  .jkl-lang-btn{background:none;border:none;cursor:pointer;font-family:'Space Mono',monospace;font-size:10px;letter-spacing:0.1em;text-transform:uppercase;color:var(--muted);padding:2px 4px;transition:color 0.2s;}
  .jkl-lang-btn.active{color:var(--gold);}
  .jkl-lang-btn:hover{color:var(--gold);}
  .jkl-lang-sep{color:var(--faint);font-family:'Space Mono',monospace;font-size:10px;}
  .jkl-hero{min-height:100vh;display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;padding:100px 48px 80px;position:relative;overflow:hidden;}
  .jkl-hero::before{content:'';position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:800px;height:800px;background:radial-gradient(ellipse,rgba(212,165,80,0.06) 0%,transparent 70%);pointer-events:none;}
  .jkl-hero-lines{position:absolute;inset:0;overflow:hidden;pointer-events:none;opacity:0.06;}
  .jkl-hero-lines::before{content:'';position:absolute;top:-200px;left:-200px;width:140%;height:140%;background:repeating-linear-gradient(-45deg,transparent 0px,transparent 60px,rgba(212,165,80,0.5) 60px,rgba(212,165,80,0.5) 61px);}
  .jkl-hero-eyebrow{font-family:'Space Mono',monospace;font-size:11px;letter-spacing:0.25em;text-transform:uppercase;color:var(--gold);margin-bottom:32px;animation:jklFadeUp 0.8s ease 0.2s both;}
  .jkl-keys{display:flex;align-items:center;justify-content:center;gap:16px;margin-bottom:40px;animation:jklFadeUp 0.9s ease 0.4s both;}
  .jkl-key{width:96px;height:96px;border:1.5px solid rgba(212,165,80,0.3);border-radius:12px;display:flex;flex-direction:column;align-items:center;justify-content:center;background:rgba(212,165,80,0.04);transition:all 0.3s ease;box-shadow:inset 0 1px 0 rgba(255,255,255,0.05),0 4px 20px rgba(0,0,0,0.4);}
  .jkl-key:hover{border-color:var(--gold);background:rgba(212,165,80,0.08);transform:translateY(-4px);box-shadow:0 12px 40px rgba(212,165,80,0.15);}
  .jkl-key-letter{font-family:'Kanit',sans-serif;font-size:42px;font-weight:900;color:var(--white);line-height:1;margin-bottom:4px;}
  .jkl-key-action{font-family:'Space Mono',monospace;font-size:8px;letter-spacing:0.1em;color:var(--gold);text-transform:uppercase;}
  .jkl-key-sep{font-family:'Space Mono',monospace;font-size:20px;color:var(--faint);margin:0 4px;}
  .jkl-hero-h1{font-family:'Kanit',sans-serif;font-size:clamp(52px,8vw,110px);font-weight:900;line-height:0.9;letter-spacing:-0.02em;text-transform:uppercase;margin-bottom:24px;animation:jklFadeUp 1s ease 0.6s both;}
  .jkl-hero-h1 .gold{color:var(--gold);}
  .jkl-hero-h1 .italic{font-family:'DM Serif Display',serif;font-style:italic;font-weight:400;font-size:0.85em;color:var(--muted);}
  .jkl-hero-sub{font-family:'Kanit',sans-serif;font-size:clamp(16px,2vw,20px);font-weight:300;color:var(--muted);max-width:620px;line-height:1.6;margin-bottom:48px;animation:jklFadeUp 1s ease 0.8s both;}
  .jkl-hero-sub strong{color:var(--white);font-weight:500;}
  .jkl-hero-actions{display:flex;align-items:center;gap:16px;animation:jklFadeUp 1s ease 1s both;}
  .jkl-btn-primary{font-family:'Kanit',sans-serif;font-size:14px;font-weight:700;letter-spacing:0.12em;text-transform:uppercase;color:var(--black);background:var(--gold);padding:16px 40px;border:none;border-radius:4px;cursor:pointer;text-decoration:none;transition:all 0.2s;display:inline-block;}
  .jkl-btn-primary:hover{background:var(--gold-lt);transform:translateY(-2px);box-shadow:0 8px 30px rgba(212,165,80,0.3);}
  .jkl-btn-ghost{font-family:'Space Mono',monospace;font-size:11px;letter-spacing:0.12em;text-transform:uppercase;color:var(--muted);background:transparent;padding:16px 32px;border:1px solid var(--border);border-radius:4px;cursor:pointer;text-decoration:none;transition:all 0.2s;display:inline-block;}
  .jkl-btn-ghost:hover{border-color:rgba(212,165,80,0.4);color:var(--gold);}
  .jkl-scroll-ind{position:absolute;bottom:40px;left:50%;transform:translateX(-50%);display:flex;flex-direction:column;align-items:center;gap:8px;animation:jklFadeUp 1s ease 1.8s both;}
  .jkl-scroll-line{width:1px;height:48px;background:linear-gradient(to bottom,var(--gold),transparent);animation:jklScrollPulse 2s ease-in-out infinite;}
  .jkl-scroll-label{font-family:'Space Mono',monospace;font-size:9px;letter-spacing:0.2em;color:var(--muted);text-transform:uppercase;}
  .jkl-manifesto{padding:120px 48px;max-width:1100px;margin:0 auto;display:grid;grid-template-columns:1fr 1fr;gap:80px;align-items:center;}
  .jkl-manifesto h2{font-family:'DM Serif Display',serif;font-size:clamp(32px,4vw,52px);font-weight:400;font-style:italic;line-height:1.2;margin-bottom:28px;}
  .jkl-manifesto h2 em{font-style:normal;color:var(--gold);}
  .jkl-manifesto p{font-family:'Kanit',sans-serif;font-size:16px;font-weight:300;color:var(--muted);line-height:1.8;margin-bottom:20px;}
  .jkl-manifesto p strong{color:var(--white);font-weight:500;}
  .jkl-postplan-mock{background:var(--card);border:1px solid var(--border);border-radius:16px;padding:28px;position:relative;overflow:hidden;font-family:'Space Mono',monospace;}
  .jkl-postplan-mock::before{content:'';position:absolute;top:0;left:0;right:0;height:2px;background:linear-gradient(90deg,transparent,var(--gold),transparent);}
  .jkl-pm-header{display:flex;justify-content:space-between;align-items:center;margin-bottom:20px;}
  .jkl-pm-title{font-size:9px;letter-spacing:0.2em;color:var(--gold);text-transform:uppercase;}
  .jkl-pm-ep{font-size:9px;color:var(--muted);letter-spacing:0.1em;}
  .jkl-pm-row{margin-bottom:12px;}
  .jkl-pm-label{font-size:8px;letter-spacing:0.12em;color:var(--muted);text-transform:uppercase;margin-bottom:5px;display:flex;justify-content:space-between;align-items:center;}
  .jkl-pm-label span{color:var(--gold);opacity:0.7;}
  .jkl-pm-bar-track{height:24px;background:rgba(255,255,255,0.03);border-radius:3px;position:relative;overflow:hidden;}
  .jkl-pm-bar{height:100%;border-radius:3px;display:flex;align-items:center;padding:0 10px;font-size:8px;letter-spacing:0.05em;color:rgba(255,255,255,0.5);}
  .jkl-pm-bar.ingest{background:rgba(212,165,80,0.15);border-left:2px solid var(--gold);width:100%;}
  .jkl-pm-bar.taglio{background:rgba(96,165,250,0.1);border-left:2px solid rgba(96,165,250,0.5);width:80%;}
  .jkl-pm-bar.montaggio{background:rgba(167,139,250,0.1);border-left:2px solid rgba(167,139,250,0.5);width:90%;}
  .jkl-pm-bar.color{background:rgba(74,222,128,0.1);border-left:2px solid rgba(74,222,128,0.5);width:60%;}
  .jkl-pm-bar.consegna{background:rgba(248,113,113,0.1);border-left:2px solid rgba(248,113,113,0.5);width:40%;}
  .jkl-pm-footer{margin-top:20px;padding-top:16px;border-top:1px solid rgba(255,255,255,0.05);display:flex;gap:8px;flex-wrap:wrap;}
  .jkl-pm-chip{background:rgba(212,165,80,0.08);border:1px solid rgba(212,165,80,0.2);padding:3px 8px;border-radius:3px;font-size:8px;color:var(--gold);letter-spacing:0.05em;}
  .jkl-pm-chip.blue{background:rgba(96,165,250,0.08);border-color:rgba(96,165,250,0.2);color:#60a5fa;}
  .jkl-pm-chip.purple{background:rgba(167,139,250,0.08);border-color:rgba(167,139,250,0.2);color:#a78bfa;}
  .jkl-fork{padding:80px 48px;border-top:1px solid var(--border);border-bottom:1px solid var(--border);background:var(--deep);}
  .jkl-fork-inner{max-width:1100px;margin:0 auto;}
  .jkl-fork-label{font-family:'Space Mono',monospace;font-size:10px;letter-spacing:0.25em;color:var(--gold);text-transform:uppercase;text-align:center;margin-bottom:16px;}
  .jkl-fork-title{font-family:'Kanit',sans-serif;font-size:clamp(28px,4vw,48px);font-weight:800;text-align:center;letter-spacing:-0.02em;text-transform:uppercase;margin-bottom:56px;line-height:1;}
  .jkl-fork-title span{color:var(--faint);}
  .jkl-fork-grid{display:grid;grid-template-columns:1fr 1fr;gap:24px;}
  .jkl-fork-card{border:1px solid var(--border);border-radius:16px;padding:48px 40px;background:var(--card);transition:all 0.3s;cursor:pointer;text-decoration:none;display:block;position:relative;overflow:hidden;}
  .jkl-fork-card::before{content:'';position:absolute;top:0;left:0;right:0;height:2px;transform:scaleX(0);transform-origin:left;transition:transform 0.4s ease;}
  .jkl-fork-card.freelance::before{background:linear-gradient(90deg,var(--gold),var(--gold-lt));}
  .jkl-fork-card.produzione::before{background:linear-gradient(90deg,#60a5fa,#a78bfa);}
  .jkl-fork-card:hover{transform:translateY(-4px);border-color:rgba(212,165,80,0.25);}
  .jkl-fork-card:hover::before{transform:scaleX(1);}
  .jkl-fork-card.produzione:hover{border-color:rgba(96,165,250,0.25);}
  .jkl-fork-icon{font-size:36px;margin-bottom:20px;display:block;}
  .jkl-fork-card h3{font-family:'Kanit',sans-serif;font-size:28px;font-weight:800;text-transform:uppercase;letter-spacing:0.05em;margin-bottom:12px;}
  .jkl-fork-card.freelance h3{color:var(--gold);}
  .jkl-fork-card.produzione h3{color:#60a5fa;}
  .jkl-fork-card p{font-family:'Kanit',sans-serif;font-size:15px;font-weight:300;color:var(--muted);line-height:1.6;margin-bottom:28px;}
  .jkl-fork-card p strong{color:var(--white);font-weight:500;}
  .jkl-fork-cta{font-family:'Space Mono',monospace;font-size:10px;letter-spacing:0.15em;text-transform:uppercase;display:flex;align-items:center;gap:8px;}
  .jkl-fork-card.freelance .jkl-fork-cta{color:var(--gold);}
  .jkl-fork-card.produzione .jkl-fork-cta{color:#60a5fa;}
  .jkl-divider{width:1px;height:80px;background:linear-gradient(to bottom,transparent,var(--gold),transparent);margin:0 auto;}
  .jkl-eyebrow{font-family:'Space Mono',monospace;font-size:10px;letter-spacing:0.25em;color:var(--gold);text-transform:uppercase;margin-bottom:16px;}
  .jkl-section-title{font-family:'Kanit',sans-serif;font-size:clamp(36px,5vw,64px);font-weight:800;letter-spacing:-0.02em;text-transform:uppercase;line-height:0.95;margin-bottom:64px;}
  .jkl-section-title .dim{color:var(--faint);}
  .jkl-freelance{padding:120px 48px;background:var(--black);border-top:1px solid var(--border);}
  .jkl-freelance-inner{max-width:1100px;margin:0 auto;}
  .jkl-freelance-intro{font-family:'Kanit',sans-serif;font-size:17px;font-weight:300;color:var(--muted);line-height:1.7;max-width:640px;margin-bottom:64px;}
  .jkl-freelance-intro strong{color:var(--white);font-weight:500;}
  .jkl-freelance-grid{display:grid;grid-template-columns:repeat(2,1fr);gap:2px;margin-bottom:60px;}
  .jkl-fl-card{background:var(--card);padding:40px 32px;position:relative;overflow:hidden;transition:background 0.3s;}
  .jkl-fl-card:hover{background:#141420;}
  .jkl-fl-card::before{content:'';position:absolute;top:0;left:0;width:100%;height:1px;background:var(--gold);transform:scaleX(0);transform-origin:left;transition:transform 0.4s ease;}
  .jkl-fl-card:hover::before{transform:scaleX(1);}
  .jkl-fl-icon{font-size:26px;margin-bottom:16px;display:block;}
  .jkl-fl-card h3{font-family:'Kanit',sans-serif;font-size:20px;font-weight:700;text-transform:uppercase;letter-spacing:0.03em;margin-bottom:10px;}
  .jkl-fl-card p{font-family:'Kanit',sans-serif;font-size:14px;font-weight:300;color:var(--muted);line-height:1.7;}
  .jkl-fl-card p strong{color:var(--white);font-weight:500;}
  .jkl-production{padding:120px 48px;background:var(--deep);border-top:1px solid var(--border);}
  .jkl-production-inner{max-width:1100px;margin:0 auto;}
  .jkl-production .jkl-eyebrow{color:#60a5fa;}
  .jkl-production-intro{font-family:'Kanit',sans-serif;font-size:17px;font-weight:300;color:var(--muted);line-height:1.7;max-width:640px;margin-bottom:64px;}
  .jkl-production-intro strong{color:var(--white);font-weight:500;}
  .jkl-prod-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:20px;margin-bottom:60px;}
  .jkl-prod-card{background:var(--card);border:1px solid var(--border);border-radius:12px;padding:28px 24px;position:relative;transition:border-color 0.25s,transform 0.25s;}
  .jkl-prod-card:hover{border-color:rgba(96,165,250,0.3);transform:translateY(-3px);}
  .jkl-prod-card.featured{border-color:rgba(96,165,250,0.35);background:linear-gradient(135deg,rgba(96,165,250,0.05) 0%,var(--card) 60%);}
  .jkl-prod-badge{display:inline-block;font-family:'Space Mono',monospace;font-size:8px;letter-spacing:0.15em;color:#60a5fa;background:rgba(96,165,250,0.1);border:1px solid rgba(96,165,250,0.25);border-radius:20px;padding:3px 10px;margin-bottom:16px;text-transform:uppercase;}
  .jkl-prod-icon{font-size:24px;display:block;margin-bottom:14px;}
  .jkl-prod-card h3{font-family:'Kanit',sans-serif;font-size:16px;font-weight:700;margin-bottom:10px;color:var(--white);}
  .jkl-prod-card p{font-family:'Kanit',sans-serif;font-size:13px;font-weight:300;color:var(--muted);line-height:1.65;}
  .jkl-prod-card p strong{color:var(--white);font-weight:500;}
  .jkl-prod-cta{text-align:center;}
  .jkl-prod-cta-btn{display:inline-block;padding:16px 36px;background:transparent;border:1px solid #60a5fa;border-radius:6px;color:#60a5fa;font-family:'Kanit',sans-serif;font-size:14px;font-weight:600;letter-spacing:0.08em;text-decoration:none;transition:all 0.2s;margin-bottom:12px;cursor:pointer;}
  .jkl-prod-cta-btn:hover{background:rgba(96,165,250,0.1);transform:translateY(-2px);}
  .jkl-prod-cta-note{font-family:'Space Mono',monospace;font-size:10px;color:var(--faint);letter-spacing:0.08em;}
  .jkl-cta-final{padding:160px 48px;text-align:center;position:relative;overflow:hidden;}
  .jkl-cta-final::before{content:'';position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:600px;height:600px;background:radial-gradient(ellipse,rgba(212,165,80,0.08) 0%,transparent 65%);pointer-events:none;}
  .jkl-cta-final h2{font-family:'Kanit',sans-serif;font-size:clamp(48px,8vw,120px);font-weight:900;text-transform:uppercase;letter-spacing:-0.02em;line-height:0.9;margin-bottom:32px;position:relative;}
  .jkl-cta-final h2 .gold{color:var(--gold);}
  .jkl-cta-final h2 .outline{-webkit-text-stroke:1px rgba(212,165,80,0.4);color:transparent;}
  .jkl-cta-final p{font-family:'Kanit',sans-serif;font-size:18px;font-weight:300;color:var(--muted);max-width:560px;margin:0 auto 48px;line-height:1.6;}
  .jkl-cta-final p strong{color:var(--white);font-weight:500;}
  .jkl-cta-note{font-family:'Space Mono',monospace;font-size:10px;letter-spacing:0.15em;color:var(--faint);text-transform:uppercase;margin-top:24px;}
  .jkl-footer{padding:48px;border-top:1px solid var(--border);display:flex;align-items:center;justify-content:space-between;}
  .jkl-footer-logo{font-family:'Kanit',sans-serif;font-size:18px;font-weight:900;letter-spacing:0.2em;color:var(--white);}
  .jkl-footer-copy{font-family:'Space Mono',monospace;font-size:10px;letter-spacing:0.1em;color:var(--muted);}
  .jkl-footer-links{display:flex;gap:24px;list-style:none;}
  .jkl-footer-links a{font-family:'Space Mono',monospace;font-size:10px;letter-spacing:0.1em;color:var(--muted);text-decoration:none;text-transform:uppercase;transition:color 0.2s;}
  .jkl-footer-links a:hover{color:var(--gold);}
  .jkl-reveal{opacity:0;transform:translateY(32px);transition:opacity 0.7s ease,transform 0.7s ease;}
  .jkl-reveal.visible{opacity:1;transform:translateY(0);}
  @keyframes jklFadeUp{from{opacity:0;transform:translateY(24px);}to{opacity:1;transform:translateY(0);}}
  @keyframes jklScrollPulse{0%,100%{opacity:0.3;}50%{opacity:1;}}
  @media(max-width:768px){
    .jkl-nav{padding:0 24px;}
    .jkl-nav-links li{display:none;}.jkl-nav-links li.jkl-nav-inside,.jkl-nav-links li:last-child{display:block;}.jkl-nav-links{gap:14px;}
    .jkl-manifesto{grid-template-columns:1fr;padding:80px 24px;gap:40px;}
    .jkl-fork-grid{grid-template-columns:1fr;}
    .jkl-fork{padding:60px 24px;}
    .jkl-freelance,.jkl-production{padding:80px 24px;}
    .jkl-freelance-grid,.jkl-prod-grid{grid-template-columns:1fr;}
    .jkl-footer{flex-direction:column;gap:16px;text-align:center;}
    .jkl-hero{padding:100px 24px 80px;}
  }
`;

const SVG_LOGO = (
  <svg width="80" height="28" viewBox="0 0 80 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0" y="0" width="22" height="22" rx="3.5" fill="rgba(212,165,80,0.12)" stroke="rgba(212,165,80,0.5)" strokeWidth="1"/>
    <text x="11" y="15.5" textAnchor="middle" fill="#d4a550" fontSize="13" fontWeight="700" fontFamily="Kanit,Inter,sans-serif">J</text>
    <rect x="29" y="0" width="22" height="22" rx="3.5" fill="rgba(212,165,80,0.12)" stroke="rgba(212,165,80,0.5)" strokeWidth="1"/>
    <text x="40" y="15.5" textAnchor="middle" fill="#d4a550" fontSize="13" fontWeight="700" fontFamily="Kanit,Inter,sans-serif">K</text>
    <rect x="58" y="0" width="22" height="22" rx="3.5" fill="rgba(212,165,80,0.12)" stroke="rgba(212,165,80,0.5)" strokeWidth="1"/>
    <text x="69" y="15.5" textAnchor="middle" fill="#d4a550" fontSize="13" fontWeight="700" fontFamily="Kanit,Inter,sans-serif">L</text>
  </svg>
);

export default function LandingPage({ onGoLogin, onGoRegister }) {
  const { t, i18n } = useTranslation();
  const lang = i18n.language?.startsWith('en') ? 'en' : 'it';
  const switchLang = (l) => i18n.changeLanguage(l);

  useEffect(() => {
    if (!document.getElementById('jkl-land-styles')) {
      const style = document.createElement('style');
      style.id = 'jkl-land-styles';
      style.textContent = STYLES;
      document.head.appendChild(style);
    }
    const reveals = document.querySelectorAll('.jkl-reveal');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry, i) => {
        if (entry.isIntersecting) {
          setTimeout(() => entry.target.classList.add('visible'), (i % 3) * 80);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    reveals.forEach(el => observer.observe(el));
    return () => { document.getElementById('jkl-land-styles')?.remove(); observer.disconnect(); };
  }, []);

  const goLogin = (e) => { e.preventDefault(); onGoLogin?.(); };
  const goRegister = (e) => { e.preventDefault(); onGoRegister?.(); };
  const scrollTo = (id) => { const el = document.getElementById(id); if (el) el.scrollIntoView({ behavior: 'smooth' }); };

  const freelanceFeatures = [
    { icon: '◈', titleKey: 'freelance.f1_title', bodyKey: 'freelance.f1_body' },
    { icon: '📅', titleKey: 'freelance.f2_title', bodyKey: 'freelance.f2_body' },
    { icon: '◻', titleKey: 'freelance.f3_title', bodyKey: 'freelance.f3_body' },
    { icon: '🔔', titleKey: 'freelance.f4_title', bodyKey: 'freelance.f4_body' },
    { icon: '◎', titleKey: 'freelance.f5_title', bodyKey: 'freelance.f5_body' },
  ];

  const productionFeatures = [
    { icon: '🔍', titleKey: 'production.p1_title', bodyKey: 'production.p1_body' },
    { icon: '📡', titleKey: 'production.p2_title', bodyKey: 'production.p2_body', featured: true, badgeKey: 'production.p2_badge' },
    { icon: '🔔', titleKey: 'production.p3_title', bodyKey: 'production.p3_body' },
    { icon: '◻', titleKey: 'production.p4_title', bodyKey: 'production.p4_body' },
    { icon: '📋', titleKey: 'production.p5_title', bodyKey: 'production.p5_body', featured: true, badgeKey: 'production.p5_badge' },
    { icon: '👥', titleKey: 'production.p6_title', bodyKey: 'production.p6_body' },
    { icon: '🔄', titleKey: 'production.p7_title', bodyKey: 'production.p7_body' },
    { icon: '👁', titleKey: 'production.p8_title', bodyKey: 'production.p8_body', featured: true, badgeKey: 'production.p8_badge' },
    { icon: '🏢', titleKey: 'production.p9_title', bodyKey: 'production.p9_body' },
    { icon: '◎', titleKey: 'production.p10_title', bodyKey: 'production.p10_body' },
    { icon: '★', titleKey: 'production.p11_title', bodyKey: 'production.p11_body' },
    { icon: '⏱', titleKey: 'production.p12_title', bodyKey: 'production.p12_body' },
  ];

  return (
    <div className="jkl-land">
      <nav className="jkl-nav">
        <span className="jkl-nav-logo">{SVG_LOGO}</span>
        <ul className="jkl-nav-links">
          <li><a href="#freelance" onClick={e=>{e.preventDefault();scrollTo('freelance');}}>{t('nav.freelance')}</a></li>
          <li><a href="#produzione" onClick={e=>{e.preventDefault();scrollTo('produzione');}}>{t('nav.production')}</a></li>
          <li className="jkl-nav-inside"><a href="/inside">INSIDE</a></li>
          <li><a href="/contatti">{t('nav.contacts')}</a></li>
          <li>
            <span className="jkl-lang-switch">
              <button className={`jkl-lang-btn${lang==='it'?' active':''}`} onClick={()=>switchLang('it')}>IT</button>
              <span className="jkl-lang-sep">|</span>
              <button className={`jkl-lang-btn${lang==='en'?' active':''}`} onClick={()=>switchLang('en')}>EN</button>
            </span>
          </li>
          <li><a href="/login" className="jkl-nav-cta" onClick={goLogin}>{t('nav.login')}</a></li>
        </ul>
      </nav>

      <section className="jkl-hero">
        <div className="jkl-hero-lines" />
        <p className="jkl-hero-eyebrow">{t('hero.eyebrow')}</p>
        <div className="jkl-keys">
          <div className="jkl-key"><span className="jkl-key-letter">J</span><span className="jkl-key-action">&larr; Back</span></div>
          <span className="jkl-key-sep">/</span>
          <div className="jkl-key"><span className="jkl-key-letter">K</span><span className="jkl-key-action">&#9632; Stop</span></div>
          <span className="jkl-key-sep">/</span>
          <div className="jkl-key"><span className="jkl-key-letter">L</span><span className="jkl-key-action">&rarr; Fwd</span></div>
        </div>
        <h1 className="jkl-hero-h1">
          {t('hero.h1_line1')}<br/>
          <span className="gold">{t('hero.h1_line2')}</span><br/>
          <span className="italic">{t('hero.h1_line3')}</span>
        </h1>
        <p className="jkl-hero-sub">{t('hero.sub')}<br/><strong>{t('hero.sub_strong')}</strong></p>
        <div className="jkl-hero-actions">
          <a href="/register" className="jkl-btn-primary" onClick={goRegister}>{t('hero.cta_primary')}</a>
          <a href="#chi-sei" className="jkl-btn-ghost" onClick={e=>{e.preventDefault();scrollTo('chi-sei');}}>{t('hero.cta_ghost')}</a>
        </div>
        <div className="jkl-scroll-ind"><div className="jkl-scroll-line"/><span className="jkl-scroll-label">{t('hero.scroll')}</span></div>
      </section>

      <section className="jkl-manifesto">
        <div className="jkl-reveal">
          <h2>{t('manifesto.h2_line1')}<br/><em>{t('manifesto.h2_em')}</em></h2>
          <p dangerouslySetInnerHTML={{ __html: t('manifesto.p1') }} />
          <p dangerouslySetInnerHTML={{ __html: t('manifesto.p2') }} />
          <p dangerouslySetInnerHTML={{ __html: t('manifesto.p3') }} />
        </div>
        <div className="jkl-reveal">
          <div className="jkl-postplan-mock">
            <div className="jkl-pm-header">
              <span className="jkl-pm-title">{t('mock.title')}</span>
              <span className="jkl-pm-ep">Ep. 01 &rarr; 08</span>
            </div>
            <div className="jkl-pm-row">
              <div className="jkl-pm-label">{t('mock.phases.ingest')} <span>R. Ferrara</span></div>
              <div className="jkl-pm-bar-track"><div className="jkl-pm-bar ingest">{t('mock.dur_ingest')}</div></div>
            </div>
            <div className="jkl-pm-row">
              <div className="jkl-pm-label">{t('mock.phases.roughcut')} <span>M. Conti</span></div>
              <div className="jkl-pm-bar-track"><div className="jkl-pm-bar taglio">{t('mock.dur_roughcut')}</div></div>
            </div>
            <div className="jkl-pm-row">
              <div className="jkl-pm-label">{t('mock.phases.editing')} <span>L. Greco &middot; S. Ricci</span></div>
              <div className="jkl-pm-bar-track"><div className="jkl-pm-bar montaggio">{t('mock.dur_editing')}</div></div>
            </div>
            <div className="jkl-pm-row">
              <div className="jkl-pm-label">{t('mock.phases.color')} <span>F. Bruno</span></div>
              <div className="jkl-pm-bar-track"><div className="jkl-pm-bar color">{t('mock.dur_color')}</div></div>
            </div>
            <div className="jkl-pm-row">
              <div className="jkl-pm-label">{t('mock.phases.delivery')}</div>
              <div className="jkl-pm-bar-track"><div className="jkl-pm-bar consegna">{t('mock.dur_delivery')}</div></div>
            </div>
            <div className="jkl-pm-footer">
              <span className="jkl-pm-chip">{t('mock.chip_ep')}</span>
              <span className="jkl-pm-chip blue">{t('mock.chip_phases')}</span>
              <span className="jkl-pm-chip purple">{t('mock.chip_coord')}</span>
            </div>
          </div>
        </div>
      </section>

      <section className="jkl-fork" id="chi-sei">
        <div className="jkl-fork-inner">
          <p className="jkl-fork-label jkl-reveal">{t('fork.label')}</p>
          <h2 className="jkl-fork-title jkl-reveal">{t('fork.title1')} <span>{t('fork.title2')}</span></h2>
          <div className="jkl-fork-grid">
            <a className="jkl-fork-card freelance jkl-reveal" href="#freelance" onClick={e=>{e.preventDefault();scrollTo('freelance');}}>
              <span className="jkl-fork-icon">🎬</span>
              <h3>{t('fork.freelance_title')}</h3>
              <p dangerouslySetInnerHTML={{ __html: t('fork.freelance_p') }} />
              <span className="jkl-fork-cta">{t('fork.freelance_cta')}</span>
            </a>
            <a className="jkl-fork-card produzione jkl-reveal" href="#produzione" onClick={e=>{e.preventDefault();scrollTo('produzione');}}>
              <span className="jkl-fork-icon">🏭</span>
              <h3>{t('fork.production_title')}</h3>
              <p dangerouslySetInnerHTML={{ __html: t('fork.production_p') }} />
              <span className="jkl-fork-cta">{t('fork.production_cta')}</span>
            </a>
          </div>
        </div>
      </section>

      <section className="jkl-freelance" id="freelance">
        <div className="jkl-freelance-inner">
          <p className="jkl-eyebrow jkl-reveal">{t('freelance.eyebrow')}</p>
          <h2 className="jkl-section-title jkl-reveal">
            {t('freelance.title1')}<br/><span className="dim">{t('freelance.title2')}</span><br/>{t('freelance.title3')}
          </h2>
          <p className="jkl-freelance-intro jkl-reveal" dangerouslySetInnerHTML={{ __html: t('freelance.intro') }} />
          <div className="jkl-freelance-grid">
            {freelanceFeatures.map((f) => (
              <div key={f.titleKey} className="jkl-fl-card jkl-reveal">
                <span className="jkl-fl-icon">{f.icon}</span>
                <h3>{t(f.titleKey)}</h3>
                <p dangerouslySetInnerHTML={{ __html: t(f.bodyKey) }} />
              </div>
            ))}
            <div className="jkl-fl-card jkl-reveal" style={{display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',textAlign:'center',background:'rgba(212,165,80,0.04)',border:'1px dashed rgba(212,165,80,0.2)'}}>
              <div style={{fontSize:36,marginBottom:16}}>◈</div>
              <p dangerouslySetInnerHTML={{ __html: t('freelance.free_text') }} style={{color:'var(--muted)',fontSize:14,marginBottom:24}} />
              <a href="/register" className="jkl-btn-primary" onClick={goRegister} style={{fontSize:13,padding:'12px 28px'}}>{t('freelance.free_cta')}</a>
            </div>
          </div>
        </div>
      </section>

      <div className="jkl-divider" />

      <section className="jkl-production" id="produzione">
        <div className="jkl-production-inner">
          <p className="jkl-eyebrow jkl-reveal">{t('production.eyebrow')}</p>
          <h2 className="jkl-section-title jkl-reveal">
            {t('production.title1')}<br/><span className="dim">{t('production.title2')}</span><br/>{t('production.title3')}
          </h2>
          <p className="jkl-production-intro jkl-reveal" dangerouslySetInnerHTML={{ __html: t('production.intro') }} />
          <div className="jkl-prod-grid">
            {productionFeatures.map((f) => (
              <div key={f.titleKey} className={"jkl-prod-card jkl-reveal"+(f.featured?' featured':'')} >
                {f.badgeKey && <span className="jkl-prod-badge">{t(f.badgeKey)}</span>}
                <span className="jkl-prod-icon">{f.icon}</span>
                <h3>{t(f.titleKey)}</h3>
                <p dangerouslySetInnerHTML={{ __html: t(f.bodyKey) }} />
              </div>
            ))}
          </div>
          <div className="jkl-prod-cta jkl-reveal">
            <a href="/register?tipo=coordinator" className="jkl-prod-cta-btn" onClick={e=>{e.preventDefault();onGoRegister&&onGoRegister("coordinator");}}>{t('production.cta_btn')}</a>
            <p className="jkl-prod-cta-note">{t('production.cta_note')}</p>
          </div>
        </div>
      </section>

      <section className="jkl-cta-final">
        <h2 className="jkl-reveal">
          {t('cta.h2_line1')}<br/>
          <span className="gold">J</span> <span className="outline">K</span> <span className="gold">L</span><br/>
          {t('cta.h2_line2')}
        </h2>
        <p className="jkl-reveal" dangerouslySetInnerHTML={{ __html: t('cta.p') }} />
        <a href="/register" className="jkl-btn-primary jkl-reveal" onClick={goRegister}>{t('cta.btn')}</a>
        <p className="jkl-cta-note jkl-reveal">
          {t('cta.login_note')} <a href="/login" style={{color:'var(--gold)',textDecoration:'none'}} onClick={goLogin}>{t('cta.login_link')}</a>
        </p>
      </section>

      <footer className="jkl-footer">
        <div className="jkl-footer-logo">{SVG_LOGO}</div>
        <p className="jkl-footer-copy">{t('footer.copy')}</p>
        <ul className="jkl-footer-links">
          <li><a href="/inside">INSIDE</a></li>
          <li><a href="/login" onClick={goLogin}>{t('footer.login')}</a></li>
          <li><a href="/register" onClick={goRegister}>{t('footer.register')}</a></li>
          <li><a href="/contatti">{t('footer.contacts')}</a></li>
        </ul>
      </footer>
    </div>
  );
}
